import { BASE_USER_URL } from 'appConstants';

export const routesAliases = {
  jobsTasksList: `${BASE_USER_URL}tasks`,
  languageManager: `${BASE_USER_URL}language-manager`,
  editJobTask: `${BASE_USER_URL}tasks/edit`,
  editJobTaskVersionRequirements: `${BASE_USER_URL}tasks/edit`,
  createJobTask: `${BASE_USER_URL}tasks/create`,
  administratorsList: `${BASE_USER_URL}administrators`,
  editAdministrator: `${BASE_USER_URL}administrators/edit`,
  createAdministrator: `${BASE_USER_URL}administrators/create`,
  trainersList: `${BASE_USER_URL}trainers`,
  editTrainer: `${BASE_USER_URL}trainers/edit`,
  createTrainer: `${BASE_USER_URL}trainers/create`,
  studentsList: `${BASE_USER_URL}students/`,
  editStudent: `${BASE_USER_URL}students/edit`,
  createStudent: `${BASE_USER_URL}students/create`,
  dashboard: `${BASE_USER_URL}dashboard`,
  myTrainingSessionsList: `${BASE_USER_URL}my-training-sessions`,
  viewMyTrainingSession: `${BASE_USER_URL}my-training-sessions/view`,
  notificationsList: `${BASE_USER_URL}notifications`,
  trainingModulesList: `${BASE_USER_URL}training-modules`,
  editTrainingModule: `${BASE_USER_URL}training-modules/edit`,
  createTrainingPart: `${BASE_USER_URL}training-modules/edit`,
  editTrainingPart: `${BASE_USER_URL}training-modules/edit`,
  trainingSessionsList: `${BASE_USER_URL}training-sessions`,
  trainingSessionSchedule: `${BASE_USER_URL}training-sessions-schedule`,
  trainingSessionStatistics: `${BASE_USER_URL}training-modules-statistics`,
  createTrainingSession: `${BASE_USER_URL}training-sessions/create`,
  editTrainingSession: `${BASE_USER_URL}training-sessions/edit`,
  eventsList: `${BASE_USER_URL}events`,
  editCompany: `${BASE_USER_URL}companies/edit`,
  createCompany: `${BASE_USER_URL}companies/create`,
  companiesList: `${BASE_USER_URL}companies`,
  editProvisionedModule: `${BASE_USER_URL}companies/edit`,
  createProvisionedTrainingPart: `${BASE_USER_URL}companies/edit`,
  editProvisionedTrainingPart: `${BASE_USER_URL}companies/edit`,
  editProvisionedRole: `${BASE_USER_URL}companies/edit`,
  editProvisionedRoleVersionRequirements: `${BASE_USER_URL}companies/edit`,
};

export const buildProvisionedModuleEditPath = (companyId, moduleId) =>
  `${routesAliases.editProvisionedModule}/${companyId}/provisioned/modules/${moduleId}`;

export const buildProvisionedTrainingPartCreatePath = (companyId, moduleId, trainingMethod) =>
  `${routesAliases.createProvisionedTrainingPart}/${companyId}/provisioned/modules/${moduleId}/parts/create/${trainingMethod}`;

export const buildProvisionedTrainingPartEditPath = (companyId, moduleId, trainingPartId, trainingMethod) =>
  `${routesAliases.editProvisionedTrainingPart}/${companyId}/provisioned/modules/${moduleId}/parts/edit/${trainingPartId}/${trainingMethod}`;

export const buildProvisionedRoleEditPath = (companyId, roleId) =>
  `${routesAliases.editProvisionedRole}/${companyId}/provisioned/roles/${roleId}`;

export const buildProvisionedRoleVersionRequirementsPath = (companyId, roleId, versionId) =>
  `${routesAliases.editProvisionedRoleVersionRequirements}/${companyId}/provisioned/roles/${roleId}/versions/${versionId}/requirements`;

export default routesAliases;
